import {
  DnsRecordStatus,
  DnsRecordType,
  EmailDomainKind,
  EmailDomainStatus,
} from 'constants/emailSendingDomains';

// The live company Email-Domains API (a .NET service) serializes its enums in PascalCase
// (`Primary`, `Pending`, `NotFound`), while the UI keys its label/variant maps and status
// comparisons off the SCREAMING_CASE constants in constants/emailSendingDomains. Match each
// incoming enum string back onto the canonical constant so the boundary owns the casing —
// unmatched values pass through untouched (no regression on an unknown value).
const canon = value =>
  String(value)
    .replace(/[_\s-]/g, '')
    .toUpperCase();

const matchEnum = (raw, enumObj) => {
  if (raw == null) {
    return raw;
  }

  const target = canon(raw);

  return Object.values(enumObj).find(value => canon(value) === target) ?? raw;
};

const normalizeRecord = record => ({
  ...record,
  type: matchEnum(record?.type, DnsRecordType),
  status: matchEnum(record?.status, DnsRecordStatus),
});

export const normalizeEmailDomain = domain =>
  domain
    ? {
        ...domain,
        kind: matchEnum(domain.kind, EmailDomainKind),
        status: matchEnum(domain.status, EmailDomainStatus),
        records: Array.isArray(domain.records)
          ? domain.records.map(normalizeRecord)
          : domain.records,
      }
    : domain;

export const normalizeEmailDomains = domains =>
  Array.isArray(domains) ? domains.map(normalizeEmailDomain) : domains;
